
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-centre/[articleCategory]",
      function () {
        return require("private-next-pages/help-centre/[articleCategory]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help-centre/[articleCategory]"])
      });
    }
  